import { motion, useScroll, useSpring } from "motion/react";
import styles from "./ScrollProgress.module.css";

/** An emerald line across the top of the window that fills as the page is read. */
export function ScrollProgress() {
  const { scrollYProgress } = useScroll();
  const scaleX = useSpring(scrollYProgress, { stiffness: 140, damping: 30, restDelta: 0.001 });
  return <motion.div className={styles.bar} style={{ scaleX }} aria-hidden="true" />;
}
